<template>
  <div class="chart missing-meters-chart" ref="chartContainer">

  </div>
</template>

<script>
require('@chartisan/chartjs');
export default {
  name: "MissingMetersChart",
  props: {
    url: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "auto",
    },
    width: {
      type: String,
      default: "auto"
    }
  },
  data(){
    return {
      chart: {}
    };
  },
  mounted() {
    if (this.height !== "auto") {
      this.$refs.chartContainer.style.height = this.height;
    }
    if (this.width !== "auto") {
      this.$refs.chartContainer.style.width = this.width;
    }
    this.chart = new Chartisan({
      el: this.$refs.chartContainer,
      url: this.url,
      hooks: new ChartisanHooks()
          .responsive()
          .colors()
          .legend(false)
          .title('Missing Meters')
          .datasets('doughnut')
          .pieColors(["red", "green"])
          .options({
            options: {
              cutoutPercentage: 80,
            }
          })
    });
  }
}
</script>

<style scoped>

</style>
